import BreadCrumb from '@components/common/BreadCrumb';
import { ContentTitle } from '@components/common/ContentTitle';
import MetaSeo from '@components/common/MetaSeo';
import useIsMobile from '@hooks/useIsMobile';
import mainImagePc from '@public/assets/2-1.webp';
import mainImageMobile from '@public/assets/m2-1.webp';
import { MainContent } from '@styles/components/LayoutStyle';
import { NextPage } from 'next';
import Image from 'next/image';

const SITE_INFO = {
  upper: '도입안내',
  title: '서비스도입 유형',
  description: '동반성장몰은 도입기관 특성에 맞는 복지몰을 설계합니다.',
};

const Index: NextPage = () => {
  const isMobile = useIsMobile();
  return (
    <>
      <MetaSeo title={SITE_INFO.title} description={SITE_INFO.description} />
      <MainContent>
        <BreadCrumb upper={SITE_INFO.upper} title={SITE_INFO.title} />
        <ContentTitle>
          동반성장몰은
          <strong style={{ color: '#5368F5' }}> 도입기관 특성</strong>에 맞는 복지몰을 설계합니다.
        </ContentTitle>
        {isMobile ? (
          <Image quality={100} src={mainImageMobile} alt="서비스도입 유형" priority={true} placeholder="blur" />
        ) : (
          <Image quality={100} src={mainImagePc} alt="서비스도입 유형" priority={true} placeholder="blur" />
        )}
      </MainContent>
    </>
  );
};

export default Index;
